import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'
import * as Styled from './DetailLinkList.styles'
import { Icon } from 'components/atoms'
import { entryPointId, mappedEntryPointRoutes } from 'settings/app/constants'

/**
 * @returns {*}
 * @constructor
 */
const DetailLinkList = ({
  headline,
  copy,
  items,
  isAsvList,
  minItems,
  linkTyp,
}) => {
  const textContext = useContext(TextContext)
  const [allVisible, setAllVisible] = useState(isAsvList)

  const handleToggleClick = () => {
    setAllVisible(!allVisible)
  }

  return (
    <Styled.DetailLinkListComponent
      allVisible={ allVisible }
      isAsvList={ isAsvList }
      className={ isAsvList ? 'isAsvList' : '' }>
      {headline && (
        <p>
          <b>{headline}</b>
        </p>
      )}
      {copy && <p className={ 'copy' }>{copy}</p>}
      <div className={ 'link-container' }>
        {items &&
          items.map(
            (itemData, index) =>
              ((!allVisible && index < minItems) || allVisible) && (
                <Link
                  className={ 'link' }
                  key={ index }
                  // to={ `${ mappedEntryPointRoutes.doctors }/${ itemData.id }` }>
                  to={ `${
                    linkTyp === entryPointId.DOCTORS
                      ? mappedEntryPointRoutes.doctors
                      : mappedEntryPointRoutes.hospitals
                  }/${ itemData.id }` }>
                  <span className={ 'label-container' }>
                    <span className={ 'name' }>{itemData.name}</span>
                    {itemData.teamLeading && (
                      <span className={ 'leader' }>(Teamleitung)</span>
                    )}
                    <span className={ 'label' }>{itemData.label}</span>
                  </span>
                  <Icon className={ 'icon-f-arrow-right-circle' } />
                </Link>
              )
          )}
      </div>
      {!isAsvList && items && items.length > minItems && (
        <p className={ 'toggle' } onClick={ handleToggleClick }>
          <u>
            {!allVisible && textContext['general.show.more']}
            {allVisible && textContext['general.show.less']}
          </u>
          <Icon className={ 'icon-f-arrow-down' } />
        </p>
      )}
    </Styled.DetailLinkListComponent>
  )
}

DetailLinkList.defaultProps = {
  isAsvList: false,
  minItems: 3,
  linkTyp: entryPointId.DOCTORS,
}

DetailLinkList.propTypes = {
  headline: PropTypes.string,
  copy: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      label: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
  /** additional params for make this component usable for asv teams **/
  isAsvList: PropTypes.bool,
  minItems: PropTypes.number,
  /** used for distinction between hospitals or doctors link **/
  linkTyp: PropTypes.string,
}

export default DetailLinkList
